import React from 'react'

const FacebookMessengerIcon = (props) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M2 11.26c0 2.912 1.453 5.512 3.726 7.21V22l3.405-1.868c.909.25 1.871.387 2.869.387 5.522 0 10-4.145 10-9.259C22 6.146 17.523 2 12 2 6.478 2 2 6.145 2 11.26zm8.945-2.594 2.609 2.716 4.906-2.716-5.467 5.801-2.546-2.715-4.97 2.716 5.468-5.802z" fill="#2196F3"/>
    </svg>

  )


export default FacebookMessengerIcon
